import { CloseButton } from '@chakra-ui/react';
import { FC } from 'react';

import { Alert, AlertBody, AlertDescription, AlertIcon, AlertTitle } from '@bonusly/ds-alert';
import { rem } from '@bonusly/ds-utils';

import { toastSemanticColors, ToastStatus } from '../types';

export interface ToastProps {
	isCloseable?: boolean;
	message: string;
	description?: string;
	onClose?: VoidFunction;
	status?: ToastStatus;
	marginTop?: number;
}

export const Toast: FC<ToastProps> = ({ isCloseable, message, description, onClose, status = 'info' }) => {
	const colors = toastSemanticColors[status];

	return (
		<Alert alignItems={description ? 'flex-start' : 'center'} status={status} boxShadow="md">
			<AlertIcon color={colors.icon} />
			<AlertBody>
				<AlertTitle color={colors.text}>{message}</AlertTitle>
				{description && (
					<AlertDescription color={colors.text} fontSize="sm" fontWeight="normal" mt={rem(4)} opacity={0.85}>
						{description}
					</AlertDescription>
				)}
			</AlertBody>
			{isCloseable && (
				<CloseButton
					backgroundColor={colors.closeBg}
					borderRadius="full"
					color={colors.text}
					ml={2}
					onClick={onClose}
					_active={{
						backgroundColor: colors.closeBgActive,
					}}
					_hover={{
						backgroundColor: colors.closeBgHover,
					}}
				/>
			)}
		</Alert>
	);
};
